import * as React from 'react';

function FileIcon(props) {
  return (
    <svg
      id='Layer_39'
      data-name='Layer 39'
      xmlns='http://www.w3.org/2000/svg'
      width={90.516}
      height={72.36}
      viewBox='0 0 90.516 72.36'
      {...props}
    >
      <path
        id='Path_23'
        data-name='Path 23'
        d='M10.045,76.359A9.045,9.045,0,0,1,1,67.314V13.045A9.045,9.045,0,0,1,10.045,4h21.1a3.015,3.015,0,0,1,2.322,1.085L42.606,16.06H79.389a3.015,3.015,0,1,1,0,6.03h-38.2A3.015,3.015,0,0,1,38.9,21L29.733,10.03H10.045A3.015,3.015,0,0,0,7.03,13.045V67.314a3.015,3.015,0,0,0,3.015,3.015,3.015,3.015,0,1,1,0,6.03Z'
        transform='translate(-1 -4)'
        fill='#fff'
      />
      <path
        id='Path_24'
        data-name='Path 24'
        d='M70.52,60.24H6.06a3.015,3.015,0,0,1-3.015-3.648L12.09,14.382A3.015,3.015,0,0,1,15.1,12H84.449a3.015,3.015,0,0,1,3.015,3.648l-8.08,37.446A9.045,9.045,0,0,1,70.52,60.24ZM9.8,54.21H70.52a3.015,3.015,0,0,0,3.015-2.382l7.176-33.8H17.4Z'
        transform='translate(2.985 12.119)'
        fill='#fff'
      />
    </svg>
  );
}
export default FileIcon;
